// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3UC2P","newExpiryDate":"styles_newExpiryDate__idXSl","footer":"styles_footer__ai7op"};